import {ProcessFlowchartPlatformFeatureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PLUGIN_REGISTRY_INSTANCE} from 'processes/graph-builder-processes/platform/PluginRegistry';

import {SidepanelTab} from './processFlowchartConfigEditorConstants';
import {
  FlowchartNode,
  isStaticTaskSchemaNodeData,
  StaticFlowchartNodeData,
} from './processFlowchartConfigEditorNodeTypes';
import {PROCESS_FLOWCHART_SIDEPANEL_TAB_BY_PLATFORM_FEATURE} from './processFlowchartConfigEditorRegistry';

export function getAllNodeDetailsSidepanelTabsForTaskNodeData(
  nodeData: StaticFlowchartNodeData,
  platformFlowchartFeatures?: Map<ProcessFlowchartPlatformFeatureType, boolean>
): Array<SidepanelTab> {
  if (!isStaticTaskSchemaNodeData(nodeData)) {
    return [];
  }
  const adapter = PLUGIN_REGISTRY_INSTANCE.getTaskSchemaNodeAdapter(
    nodeData.taskDefinitionVersionSpec.newProcessTaskDefinitionVersion.taskSchema.executionType
  );
  const tabs = [...adapter.nodeDetailsSidepanelContent];

  if (platformFlowchartFeatures == null) {
    return tabs;
  }

  for (const [feature, enabled] of platformFlowchartFeatures) {
    if (enabled && PROCESS_FLOWCHART_SIDEPANEL_TAB_BY_PLATFORM_FEATURE[feature] != null) {
      tabs.push(...PROCESS_FLOWCHART_SIDEPANEL_TAB_BY_PLATFORM_FEATURE[feature]);
    }
  }
  return tabs;
}

export default function getAllNodeDetailsSidepanelTabsForTaskNode(
  node: FlowchartNode,
  platformFlowchartFeatures?: Map<ProcessFlowchartPlatformFeatureType, boolean>
): Array<SidepanelTab> {
  return getAllNodeDetailsSidepanelTabsForTaskNodeData(node.data, platformFlowchartFeatures);
}
